export const REQUEST_ADD = "containers/Addressbook/REQUEST_ADD"
export const RECEIVE_ADD = "containers/Addressbook/RECEIVE_ADD"
export const REQUEST = "containers/Addressbook/REQUEST"
export const RECEIVE = "containers/Addressbook/RECEIVE"
export const SAVE_UI = "containers/Addressbook/SAVE_UI"
export const SET_FILTER = "containers/Addressbook/SET_FILTER"
export const APPLY_FILTER = "containers/Addressbook/APPLY_FILTER"
export const SET_CURRENT_FILTER = "containers/Addressbook/SET_CURRENT_FILTER"
